import { createContext, useMemo, useState } from "react";
import { ConnectedObjectType } from "../types/connected-object";

type EditContextType = {
  object: ConnectedObjectType | null;
  editObject: React.Dispatch< React.SetStateAction<ConnectedObjectType|null>>
}

type EditProviderProps = {
  children: React.ReactNode
}

export const EditContext = createContext<EditContextType | null>(null);

export const EditProvider = ({children}: EditProviderProps) => {

  const [object, editObject] = useState<ConnectedObjectType|null>(null);

  const value = useMemo(() => ({object, editObject}), [object, editObject]);

  return (
    <EditContext.Provider value={value}>
      {children}
    </EditContext.Provider>
  )
}